export const RetryStatusCodes = [504, 502];
